import { Box, Button, Heading, HStack } from '@chakra-ui/react';
import {
  TextInput,
  useBoolean,
} from '@laxmimanogna/code-quick-components';
import React, { useContext, useEffect } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import AppColors from '../../constants/AppColors';
import { SearchIcon } from '../../constants/IconData';
import { FONT_FAMILY } from '../../constants/Theme';
import { withProvider } from '../../hoc/withProvider';
import AccountsProvider, {
  AccountContext,
} from '../../providers/AccountsProvider';
import AddHealthSystemAccountForm from './forms/AddHealthSystemAccountForm';
import AccountsTable from './table/AccountsTable';

function AccountsContainer() {
  const accountsContext = useContext(AccountContext);
  const { getAccountsList, accountFilters, getArchivedAccountsList, archivedAccountFilters } = accountsContext;
  const [searchItem, setSearchItem] = React.useState('');
  const [archivedSearchItem, setArchivedSearchItem] = React.useState('');
  const [ordering, setOrdering] = React.useState('');

  const [accountFormVisible, afvState] = useBoolean(false);
  const [showArchived, saState] = useBoolean(false);

  function handleOpenAddAccount() {
    afvState.on();
  }

  const onSearchAction = async () => {
    if (showArchived) {
      accountsContext.setArchivedAccountFilters(prev => ({ ...prev, search: archivedSearchItem }));
    } else {
      accountsContext.setAccountFilters(prev => ({ ...prev, search: searchItem }));
    }
  };

  useEffect(() => {
    if (showArchived) {
      let searching = !!(archivedAccountFilters.search && archivedAccountFilters.search.trim());
      getArchivedAccountsList.loadAPI("Archived Accounts", "ArchivedAccounts", searching);
    } else {
      let searching = !!(accountFilters.search && accountFilters.search.trim());
      getAccountsList.loadAPI("Manage Accounts", "Accounts", searching);
    }
  }, [accountFilters, archivedAccountFilters, showArchived, getAccountsList.showOrdering, getArchivedAccountsList.showOrdering]);


  const onFilterChange = e => {
    if (e && e.target.value) {
      if (showArchived) {
        getArchivedAccountsList.setParams({ page: 1 });
        setArchivedSearchItem(e.target.value);
      } else {
        getAccountsList.setParams({ page: 1 });
        setSearchItem(e.target.value);
      }
    } else {
      if (showArchived) {
        setArchivedSearchItem('');
      } else {
        setSearchItem('');
      }
    }
  };

  useEffect(() => {
    if (showArchived) {
      getArchivedAccountsList.setParams({ ordering });
    } else {
      getAccountsList.setParams({ ordering });
    }
  }, [ordering]);

  //useEffect to clear search when switching views
  useEffect(() => {
    if (showArchived) {
      setArchivedSearchItem('');
      accountsContext.setArchivedAccountFilters({});
    } else {
      setSearchItem('');
      accountsContext.setAccountFilters({});
    }
  }, [showArchived]);

  return (
    <CQContainer>
      <HStack
        w={'100%'}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={4}
      >
        <Heading
          variant={'h6'}
          fontSize={'x-large'}
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight={600}
          width={'114px'}
          height={'30px'}
        >
          {showArchived ? 'Archived' : 'Accounts'}
        </Heading>
        <HStack>
          <Button
            variant="solid"
            style={{height:'50px'}}
            borderRadius={25}
            fontWeight={500}
            backgroundColor={AppColors.primary}
            width={'186px'}
            onClick={showArchived ? saState.off : saState.on}
            height={'40px'}
            color={'white'}
            outline={`2px`}
            _hover={{
              transition: 'all .1s ease',
              bgColor: AppColors.white,
              color: AppColors.primary,
              outline: `2px solid ${AppColors.primary}`,
            }}
          >
            {showArchived ? 'Accounts' : 'Archived'}
          </Button>
          
          {!showArchived && ( // WRAP EXISTING BUTTON
            <Button
              variant="solid"
              style={{height:'50px'}}
              borderRadius={25}
              fontWeight={500}
              backgroundColor={AppColors.primary}
              width={'186px'}
              paddingInline={'80px'}
              onClick={handleOpenAddAccount}
              height={'40px'}
              color={'white'}
              outline={`2px`}
              _hover={{
                transition: 'all .1s ease',
                bgColor: AppColors.white,
                color: AppColors.primary,
                outline: `2px solid ${AppColors.primary}`,
              }}
            >
              + Add New Account
            </Button>
          )}
          <TextInput
            borderRadius={'md'}
            style={{height:'50px'}}
            rightIconProps={{ zIndex: 0 }}
            placeholder="Search"
            value={showArchived ? archivedSearchItem : searchItem}
            rightIcon={<SearchIcon onClick={onSearchAction} />}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                onSearchAction();
              }
            }}
            onChange={e => onFilterChange(e)}
          />
        </HStack>
      </HStack>

      <Box bg="white" p={4} w="100%" borderRadius="md" ml={0}>
        <AccountsTable searchValue={showArchived ? archivedSearchItem : searchItem} setOrdering={setOrdering} showArchived={showArchived}/>
      </Box>

      {/* FORM MODAL */}
      <AddHealthSystemAccountForm
        isOpen={accountFormVisible}
        onClose={afvState.off}
      />
    </CQContainer>
  );
}

export default withProvider(AccountsProvider, AccountsContainer);
